<template>
  <div>
    <h5>
      {{ "check_phone_number" | setText("Проверка номера телефона") }}
      {{ order.client.phone }}
    </h5>
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.save();
    },
    prev() {
      this.$emit("next", this.index - 1);
    },
    save() {
      logger(this.$http, {
        name: "Проверка пользователя в #INTEND",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
        partner_id: this.partner.id,
      });

      this.$loading(true);
      this.$http
        .post(
          `${this.partner["endpoint_url"]}member/check`,
          {
            username: this.order.client.phone.replace("+998", ""),
          },
          {
            headers: {
              "api-key": `${this.partner["api_public_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            switch (response.data.data.status) {
              case -1:
                this.message = "Пользователь не существует в системе";
                this.$emit("next", 1); // run to create order
                break;
              case 0:
                this.message = "Пользователь заблокировоан";
                // this.$emit('next', -1); // run to create order
                this.$emit("next", 0); // test
                break;
              case 1:
                this.$emit("next", 2); // run to create order
                this.message = "Пользователь проверен";
                break;
              default:
                this.message = "Неизвестная ошибка";
                break;
            }
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          }

          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Проверка пользователя в #INTEND",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Проверка пользователя в #INTEND",
            description: "Ошибка в системе #INTEND",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
    };
  },
};
</script>
<style lang="scss">
</style>
